// extracted by mini-css-extract-plugin
module.exports = {"cards":"Accueil_cards__3Dg_y","img":"Accueil_img__P0LZz"};